<div class="back-nav">
  <span class="prev-page" (click)="onClick()">
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
    Back</span>
</div>

